import { useState } from "react";
import { toast } from "react-toastify";
import { deleteGroups } from "../../../../service/test-group";

interface DeleteClassModalProps {
  selectedId?: string | null;
  setSelectedId?: (id: string | null) => void;
  fetchData?: () => void;
}

const DeleteGroupModal = ({
  selectedId,
  setSelectedId,
  fetchData,
}: DeleteClassModalProps) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async (e: React.MouseEvent) => {
    e.preventDefault();
    if (!selectedId || isDeleting) return;

    try {
      setIsDeleting(true);
      await deleteGroups(selectedId);
      toast.success("Group deleted successfully!");

      setSelectedId?.(null);
      fetchData?.();
    } catch (error: any) {
      if (
        error.response?.data?.message ===
        "Cannot delete test group because it has associated registrations"
      ) {
        toast.error(
          "Cannot delete test group because it has associated registrations"
        );
      } else {
        toast.error("Failed to delete group");
      }
      console.error("Delete error:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="modal fade" id="delete-modal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body text-center">
            <span className="delete-icon">
              <i className="ti ti-trash-x" />
            </span>
            <h4>Confirm Deletion</h4>
            <p>
              Are you sure you want to delete this group? This action cannot be
              undone.
            </p>
            <div className="d-flex justify-content-center">
              <button className="btn btn-light me-3" data-bs-dismiss="modal">
                Cancel
              </button>
              <button
                className="btn btn-danger"
                onClick={handleDelete}
                disabled={isDeleting}
                data-bs-dismiss="modal"
              >
                {isDeleting ? "Deleting..." : "Yes, Delete"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteGroupModal;
